import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { Props } from './select.type';

import './select.css';
export const Select = forwardRef(
  (
    { hasError, isEmpty, selectFontLight, children, readOnly, disabled, ...props }: Props,
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    return (
      <select
        {...props}
        disabled={disabled}
        className={classNames(
          {
            'border-soft focus:border-medium': !hasError,
            'border-critical-no-bg': hasError,
            'cursor-not-allowed bg-tertiary opacity-50': readOnly,
            // `pointer-events-none` is the lock for `readOnly` because
            // `<select readOnly>` isn't honoured natively. Drop it when
            // `disabled` is also present — the native disabled attribute
            // already blocks interaction, and `pointer-events-none` would
            // hide the `cursor-not-allowed` we want users to see.
            'pointer-events-none': readOnly && !disabled,
            'fill-primary': !readOnly,
            'text-tertiary': isEmpty,
            'text-primary': !isEmpty,
            'text-subtitle-m': !selectFontLight,
            'text-body-m': selectFontLight,
          },
          'select w-full py-3 pl-3 pr-8 rounded-md border text-body-m placeholder:text-tertiary focus:outline-hidden focus:ring-0'
        )}
        ref={ref}>
        {children}
      </select>
    );
  }
);
